import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/LogoPIM.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  id: "divLogo",
  class: "logo"
}
const _hoisted_3 = ["href"]

import { computed, defineAsyncComponent, ref, watch } from "vue";
import { useUserStore } from "./store/UserStore";
import { useCommonStore } from "./store/CommonStore";
import { useFasesStore } from "./store/FaseStore";
// import AutoLogin from './components/AutoLogin.vue';
import { useClientesStore } from "./store/ClientesStore";
import { useTareasStore } from "./store/TareasStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const DialogTareasPendientes = defineAsyncComponent(
  () => import("./components/DialogTareasPendientes.vue")
);
const UserStore = useUserStore();
const CommonStore = useCommonStore();
const FasesStore = useFasesStore();
const ClientesStore = useClientesStore();
const TareasStore = useTareasStore()
const signedIn = computed(() => UserStore.signedIn);
const appUrl = window.location.origin
// const windowWidth = ref(window.innerWidth)
const dialogTareasPendientesVisible = ref(false)
watch(signedIn, async (signedIn) => {
  if (signedIn) {
    // Cargar datos
    await FasesStore.GetFases();
    await CommonStore.GetDatosMaestros();
    ClientesStore.GetClientes();
  }
});

UserStore.ConfigureProvider()
const ShowDialogTareasPendientes = (value: boolean) => {
  dialogTareasPendientesVisible.value = value;
};

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_header, {
          id: "rowLogo",
          class: "main-header"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("a", { href: _unref(appUrl) }, _cache[1] || (_cache[1] = [
                        _createElementVNode("img", {
                          id: "imgLogo",
                          class: "logo",
                          src: _imports_0,
                          alt: "iPIM-Pro logo"
                        }, null, -1)
                      ]), 8, _hoisted_3)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 2,
                  sm: 6,
                  md: 8,
                  lg: 11,
                  xl: 13
                }),
                _createVNode(_component_el_col, {
                  xs: 8,
                  sm: 6,
                  md: 5,
                  lg: 4,
                  xl: 3,
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_badge, {
                      value: _unref(TareasStore).NumTareasPendientes,
                      class: "item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          round: "",
                          class: "buttonIdilia",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (ShowDialogTareasPendientes(true)))
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode(" Mis tareas ")
                          ])),
                          _: 1,
                          __: [2]
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_unref(DialogTareasPendientes), {
                      visible: dialogTareasPendientesVisible.value,
                      onShowDialogTareasPdtes: ShowDialogTareasPendientes
                    }, null, 8, ["visible"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 9,
                  sm: 8,
                  md: 7,
                  lg: 5,
                  xl: 3,
                  justify: "end"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "login" }, [
                      _createElementVNode("mgt-login", { id: "mgtLogin" }, [
                        _createElementVNode("div", { "data-type": "signed-out" }, " Sign In ")
                      ])
                    ], -1)
                  ])),
                  _: 1,
                  __: [3]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(UserStore).signedIn]
        ]),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "main-body" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})